const commandList = [
  { href: '#intro', desc: 'Introduce Myself (intro)' },
  { href: '#edu', desc: 'Education (edu)' },
  { href: '#lang', desc: 'Language (lang)' },
  { href: '#stskill', desc: 'Strong Skill (stskill)' },
  { href: '#pskill', desc: 'Programming Skill (pskill)' },
  { href: '#sskill', desc: 'Soft Skill (sskill)' },
  { href: '#exp', desc: 'Experience (exp)' },
  { href: '#contact', desc: 'Contact (contact)' },
];

export { commandList };
